import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IIssueAtLocationOutput } from "../../../../logic/api";
import { useDate } from "../../../../utility/useDate";
import styles from "../condensedLayout/styles";
import vehicleIssueStyles from "./styles";
import { getStatusLabel, getStatusColorMui, getIssueTypeLabel } from "./issueUtils";

interface IssueRowProps {
  issue: IIssueAtLocationOutput;
  rowIndex: number;
  onClick: () => void;
}

const IssueRow: React.FunctionComponent<IssueRowProps> = ({ issue, rowIndex, onClick }) => {
  const { colors } = vehicleIssueStyles;

  const { t } = useTranslation();
  const { toFormattedFullDateTimeString } = useDate();

  const rowStyles = {
    ...(rowIndex % 2 ? styles.tableRowOdd : styles.tableRowEven),
    cursor: "pointer",
  };

  const formatDateTime = (dateString: string): string => {
    try {
      return toFormattedFullDateTimeString(new Date(dateString));
    } catch {
      return dateString;
    }
  };

  const issueTypeLabel = getIssueTypeLabel(issue.issue, t);

  return (
    <tr data-testid={`issue-row-${issue.id}`} style={rowStyles} onClick={onClick}>
      <td style={styles.tableCell}>
        <div>
          <div style={{ fontWeight: "medium" }}>{issueTypeLabel}</div>
          <div style={{ fontSize: "0.75rem", color: colors.darkGray }}>{issue.issueType}</div>
        </div>
      </td>

      <td style={styles.tableCell}>{issue.locationParentName} / {issue.locationName}</td>

      <td style={styles.tableCell}>
        <div>
          <div>{issue.vehicleReg}</div>
          <div style={{ fontSize: "0.75rem", color: colors.darkGray }}>
            {issue.vehicleMake} {issue.vehicleModel}
          </div>
        </div>
      </td>

      <td style={styles.tableCell}>
        {issue.recordedAt ? formatDateTime(issue.recordedAt) : "-"}
      </td>

      <td style={styles.tableCell}>
        {issue.expectedReturnTime ? formatDateTime(issue.expectedReturnTime) : "-"}
      </td>

      <td style={styles.tableCell}>
        <Chip
          label={getStatusLabel(issue.status, t)}
          color={getStatusColorMui(issue.status)}
          size="small"
        />
      </td>

      <td style={styles.tableCell}>
        <FiChevronRight />
      </td>
    </tr>
  );
};

export default IssueRow;